<template>
	<div 
		:class="['overlay-mask-container', openState ? 'open' : 'closed']"
		@click="dismissOverlayMask">
	</div>
</template>


<script>
import { mapFields } from 'vuex-map-fields'

export default {
	name: 'overlay-mask-container',

	computed: {
		...mapFields({ 
				openState: 'ui.overlayMask.openState'
		})
	},

	methods: {
		dismissOverlayMask() {
			this.openState = false
		}
	}
}
</script>